import GoogleMapBase from 'google-map-react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
`;

export type GoogleMapProps = GoogleMapBase.Props & {
  className?: string;
};

export const GoogleMap = ({
  bootstrapURLKeys = {
    key: process.env.GOOGLE_MAPS_API_KEY as unknown as string,
  },
  children,
  className,
  ...props
}: GoogleMapProps) => (
  <Container className={className}>
    <GoogleMapBase bootstrapURLKeys={bootstrapURLKeys} {...props}>
      {children}
    </GoogleMapBase>
  </Container>
);
